import { useCallback, useRef, useState } from 'react';
import HeaderSearch from '@shared/components/HeaderSearch';
import { Urls, buildURL, callApi } from '@/helpers/api-urls';

const toSuggestion = (item) => ({ title: item?.name ?? '' });

const openScenario = (id) => window.open(`/scenario-builder/${id}`, '_blank');

const GlobalSearch = () => {
  const [ suggestions, setSuggestions ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  // responses can arrive out of order; only the latest query's may update the list
  const latestQueryRef = useRef('');

  const onQueryChange = useCallback(async (query) => {
    latestQueryRef.current = query;
    setLoading(true);
    const response = await callApi.post(buildURL(Urls.GetSearchBoxOptions), { searchKey: query });
    if (latestQueryRef.current !== query) {
      return;
    }
    setSuggestions(response?.responseData ?? []);
    setLoading(false);
  }, []);

  const onClear = useCallback(() => {
    latestQueryRef.current = '';
    setLoading(false);
    setSuggestions([]);
  }, []);

  const onSelect = useCallback((item) => openScenario(item.id), []);

  const onSearch = useCallback((query) => {
    const match = suggestions.find((item) => item?.name === query);
    if (match) {
      openScenario(match.id);
    }
  }, [ suggestions ]);

  return (
    <HeaderSearch
      placeholder="Search Trip ID, Airport, Operator, Client and Tail#"
      suggestions={suggestions}
      loading={loading}
      toSuggestion={toSuggestion}
      onQueryChange={onQueryChange}
      onSelect={onSelect}
      onSearch={onSearch}
      onClear={onClear}
      debounceMs={1000}
    />
  );
};

export default GlobalSearch;
